import React from 'react';

import { connect } from 'react-redux';


const connectWithStore = (store, WrappedComponent, ...args) => {
    var ConnectedWrappedComponent = connect(...args)(WrappedComponent)
    return function (props) {
      return <ConnectedWrappedComponent {...props} store={store} />
    }
  }

export default connectWithStore